import React, { Component } from 'react';
import { Card, Row, Col, Form, Button, notification } from 'antd';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { syncExpediaARI } from 'utils/apis/integration';
import FormDatePickerRange from 'components/FormDatePickerRange/FormDatePickerRange';
import './ExpediaSyncForm.css';
import moment from 'moment';
import intl from 'react-intl-universal';

class ExpediaSyncForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSaving: false
    };
    this.handleOnFormSubmit = this.handleOnFormSubmit.bind(this);
  }

  handleOnFormSubmit = e => {
    const { handleModalCancel } = this.props;
    e.preventDefault();
    const { form, expediaData } = this.props;
    form.validateFieldsAndScroll((err, values) => {
      let body = {};
      if (!err) {
        body = {
          expediaId: expediaData._id,
          startDate: moment(values.dateRange[0]._d).format('YYYY-MM-DD'),
          endDate: moment(values.dateRange[1]._d).format('YYYY-MM-DD')
        };
        this.setState({
          isSaving: true
        });
        const syncExpedia = syncExpediaARI(body);
        return Promise.all([syncExpedia])
          .then(() => {
            this.setState({
              isSaving: false
            });
            notification.success({
              message: intl.get('hostConnect.integration.message.successSyncExpedia').d('Successfully sync to expedia!')
            });
            handleModalCancel();
          })
          .catch(ex => {
            this.setState({
              isSaving: false
            });
            notification.error({
              message: ex.message
            });
          });
      }
    });
  };

  render() {
    const { expediaData, form } = this.props;
    const { isSaving } = this.state;
    return (
      <Form onSubmit={this.handleOnFormSubmit} style={{ width: '100%' }}>
        <Card
          title={`${intl.get('hostConnect.integration.headerLabels.syncTo').d('Sync to')} ${expediaData.expediaPropertyName} | ${
            expediaData.expediaPropertyId
          }`}
        >
          <Row type="flex" justify="space-between" className={'formTitleContainer'}>
            <p className={'formTitle'}>{expediaData.propertyName}</p>
          </Row>
          <Row type="flex" justify="space-between" className={'formItemContainer'}>
            <Col span={24} className={'formItem'}>
              <FormDatePickerRange
                form={form}
                label={intl.get('hostConnect.integration.headerLabels.dataSyncExpedia').d('Select date to sync with expedia')}
                fieldName="dateRange"
                requiredErrorMessage={intl.get('hostConnect.integration.placeholder.dateMsg').d('Please select a range of dates')}
                defaultPickerValue={[moment(), moment().add('years', 1)]}
              />
            </Col>
          </Row>
          <Row type="flex" align="center" justify="bottom">
            <Col span={24}>
              <Button type="primary" size="default" htmlType="submit" loading={isSaving}>
                {isSaving
                  ? intl.get('hostConnect.integration.headerLabels.syncing').d('Syncing')
                  : intl.get('hostConnect.integration.headerLabels.sync').d('Sync')}
              </Button>
            </Col>
          </Row>
        </Card>
      </Form>
    );
  }
}

ExpediaSyncForm.propTypes = {
  expediaData: PropTypes.object.isRequired,
  handleModalCancel: PropTypes.func.isRequired
};

export default withRouter(Form.create()(ExpediaSyncForm));
